module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1920-e16c00ec7070ac4f5792d2000f810de0.jpg";